<template>
  <v-navigation-drawer
    fixed
    height="110%"
    absolute
    permanent
    left
    dark
    style="padding:30px"
  >
    <v-list-item three-line>
      <router-link to="/dashboard"
        ><img src="../assets/Tippings.png" width="100px" height="100px" />
      </router-link>
    </v-list-item>

    <v-list shaped>
      <v-list-item-group color="#e50914">
        <v-list-item
          v-for="item in items"
          :key="item.title"
          :to="item.link"
          link
        >
          <v-list-item-icon>
            <v-icon color="white">{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content :to="item.link" style="color:white">
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-btn
          depressed
          rounded
          x-large
          :to="`/${username}`"
          class="mt-7 white--text"
          color="#e50914"
        >
          Tippings Page</v-btn
        >
        <v-list-item style="margin-top:70px">
          <v-list-item-icon color="white">
            <v-icon color="white">mdi-power-standby</v-icon>
          </v-list-item-icon>
          <v-list-item-content @click="logOut()" style="color:white">
            <v-list-item-subtitle>Log out</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { getAuth, signOut, onAuthStateChanged } from "firebase/auth";
import { mapState } from 'vuex';

export default {
  name: "NavMenu",
  components: {},

  data: () => ({
    items: [
      { title: "Dashboard", icon: "mdi-chart-bar", link: "/dashboard" },
      {
        title: "Activity",
        icon: "mdi-heart-circle",
        link: "/activity",
      },
      { title: "Escrow", icon: "mdi-cash", link: "/escrow" },
      { title: "Subscribers", icon: "mdi-account-group", link: "/subscribers" },
       { title: "Newsletters", icon: "mdi-email", link: "/newsletters" },
      { title: "Settings", icon: "mdi-cog", link: "/settings" },
    ],
    user: "",
  }),

  props:{
  },

  computed:{
    ...mapState({
      username:"username"
    })
  },

  created() {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (!user) {
        this.$router.push("/login");
      }
    });
  },

  methods: {
   
    logOut() {
      localStorage.removeItem('tippingsKey')
      const auth = getAuth();
      signOut(auth)
        .then(() => {
          // Sign-out successful.
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
